import { FC } from 'react';
import Link from 'next/link';
import { gtmMenuNavigation } from 'helpers/utils/gtm-events/gtmInteraction';
import AmplienceNavItem, { AmplienceNavItemProps } from '../nav-item';

export interface AmplienceNavColumnProps {
  mainLink: string;
  mainTitle: string;
  rows: Array<AmplienceNavItemProps>;
  // Used to display images in a different aspect ratio
  isFooterColumn?: boolean;
  // If more than one column share a common title only show one
  // used on desktop to de-duplicate matching titles
  hideTitle?: boolean;
}

const AmplienceNavColumn: FC<AmplienceNavColumnProps> = ({ mainLink, mainTitle, rows, isFooterColumn, hideTitle }) => {
  return (
    <div>
      {mainTitle && !hideTitle ? (
        mainLink ? (
          <Link
            onClick={() => {
              gtmMenuNavigation({ click_location: isFooterColumn ? 'footer' : 'header', click_name: mainTitle });
            }}
            href={mainLink || ''}
            className="text-sm font-semibold text-[#222222] hover:underline"
            aria-label={mainTitle}
          >
            {mainTitle}
          </Link>
        ) : (
          <div className="text-sm font-semibold text-[#222222]">{mainTitle}</div>
        )
      ) : (
        <div className="h-[23px]" />
      )}

      <ul className="mt-3 space-y-1">
        {rows?.map((row, index) => {
          return (
            <AmplienceNavItem
              isFooterColumn={isFooterColumn}
              {...row}
              key={`nav-item-${mainTitle}-${row.title}-${index}`}
            />
          );
        })}
      </ul>
    </div>
  );
};

export default AmplienceNavColumn;
